import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Inventory.frontend.types'

@Injectable({ providedIn: 'root' })
export class Inventory_add_serials_inventory_on_existing_licenseplate_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { lotId: number, packagingId: number, reasoncodeId: number, operationcodeId: number, licenseplateId: number, serialNumbers: { LookupCode?: string, NetWeightValue?: number, GrossWeightValue?: number, WeightUOM?: number, Width?: number, Height?: number, Length?: number, DimensionUOM?: number, NetVolumeValue?: number, GrossVolumeValue?: number, VolumeUOM?: number }[] }): Promise<{ reasons?: string[], confirm?: boolean, licenseplateId?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.packagingId)) {
      $missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil($inParams.reasoncodeId)) {
      $missingRequiredInParams.push('\'reasoncodeId\'');
    }
    if (isNil($inParams.operationcodeId)) {
      $missingRequiredInParams.push('\'operationcodeId\'');
    }
    if (isNil($inParams.licenseplateId)) {
      $missingRequiredInParams.push('\'licenseplateId\'');
    }
    if (isNil($inParams.serialNumbers)) {
      $missingRequiredInParams.push('\'serialNumbers\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

